import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // iOS HIG Input Style
          "flex h-11 w-full rounded-lg border-2 border-input bg-muted/10 px-3 py-2 text-base ring-offset-background",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground",
          // iOS Focus State - 2pt border
          "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0",
          "transition-all duration-200 ease-[cubic-bezier(0.34,1.56,0.64,1)]",
          // Error State
          "aria-[invalid=true]:border-destructive",
          // Success State
          "aria-[valid=true]:border-success",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-sm",
          "dark-premium:bg-muted/20 dark-premium:border-glass-border dark-premium:backdrop-blur-sm",
          "dark-premium:focus-visible:border-primary dark-premium:focus-visible:shadow-glow-primary",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
